import { render } from "./ExtracurricularView.vue?vue&type=template&id=1fa38494"
import script from "./ExtracurricularView.vue?vue&type=script&lang=js"
export * from "./ExtracurricularView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__